import React from 'react';

function AudioPodcast() {

    let playerStyle = {
                borderBottom:"1px solid red",
                padding:" 0 0 10px 0",
                textAlign:"center",
                display:"block",
                margin:"10px",
    }

    return (
        <div style={{
            border:"2px solid purple",
            margin:"10px 0 0 0",
            padding:'10px'
        }}>
            <h1>My Podcast</h1>
            <audio controls style={playerStyle}>
                <source src={require("../assets/audio_1.ogg")}/>
            </audio>
            <br />
            <audio controls style={playerStyle}>
                <source src={require("../assets/audio_2.ogg")}/>
            </audio>
            <br />
            <audio controls style={playerStyle}>
                <source src={require("../assets/audio_3.ogg")}/>
            </audio>
        </div>
      );
}

export default AudioPodcast;